import React, {useContext, useState} from "react"
import {useParams} from "react-router";
import DemandOffersOfferService from "services/DemandOffersOfferService";
import OfferCommonDataForm from "../../../../common/commonData/OfferCommonDataForm";
import PurchaserOfferContext from "context/PurchaserOfferContext";
import {ContractorConsorciumTypes} from "constants/ContractorConsorciumTypes";
import {simpleAlert} from "libs/AlertNotification";
import OfferStageTranslationsContext from "context/OfferStageTranslationsContext";
import scrollTo from "libs/scrollTo";

export const CONTRACTOR_OFFER_EDIT_COMMON_DATA_FORM_ID = "cont_offer_edit_common_data";

function OfferCommonData(
    {
        offerEdit,
        disabled,
        section
    }) {
    const params = useParams();
    const [working, setWorking] = useState(false)
    const purchaserOfferContext = useContext(PurchaserOfferContext)
    const stageTr = useContext(OfferStageTranslationsContext);


    const onSubmit = (values, actions) => {
        setWorking(true);
        DemandOffersOfferService.postSaveCommonData(params.id, params.stageId, purchaserOfferContext?.supplierId, values).then((resp) => {
            if (resp) {
                if (offerEdit.commonData.consorciumType !== ContractorConsorciumTypes.POSITION && values.consorciumType === ContractorConsorciumTypes.POSITION) {
                    simpleAlert(stageTr("consorcium_on_position_info"), false);
                    scrollTo("#wrap_offerPositionForm_" + offerEdit.positions[0].positionId, 60);
                }

                actions.resetForm({
                    values: values
                });
            }
        }).finally(() => setWorking(false))
    }

    return <OfferCommonDataForm
        disabled={disabled}
        offerEdit={offerEdit}
        section={section}
        onSubmit={onSubmit}
        formId={CONTRACTOR_OFFER_EDIT_COMMON_DATA_FORM_ID}
        working={working}
    />
}

OfferCommonData.propTypes = {}
export default OfferCommonData;